import script from "./AdtTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdtTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./AdtTemplate.vue?vue&type=style&index=0&id=28abb692&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28abb692"]])

export default __exports__